import { render, staticRenderFns } from "./Operatsiya.vue?vue&type=template&id=2a5b01b4&scoped=true"
import script from "./Operatsiya.vue?vue&type=script&lang=js"
export * from "./Operatsiya.vue?vue&type=script&lang=js"
import style0 from "./Operatsiya.vue?vue&type=style&index=0&id=2a5b01b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5b01b4",
  null
  
)

export default component.exports